module.exports = __webpack_public_path__ + "img/al.93e162db.svg";